import API from "@/api/index";
import axios from "axios";

export async function categoryUploadUrl(context, payload) {
  try {
    if (payload.name == "") {
      throw new Error("Error saving the image, try again");
    } else {
      console.log("Request");
      const res = await API.domain.uploadCategoryFile({
        body: {
          base64: payload.dataURL,
          name: payload.name,
          type: payload.type,
          form: true,
        },
      });
      return res.data;
    }
  } catch (e) {
    console.log(e.message);
    return false;
  }
}

export async function saveFormAPI(context, payload) {
  try {
    const res = await API.domain.crudForms({
      body: {
        option: payload.option,
        form_name: payload.form_name,
        form_description: payload.form_description,
        form_image: payload.form_image,
        form_style: payload.form_style,
        inputs: payload.inputs,
        final_information: payload.final_information,
        final_title: payload.final_title,
      },
    });
    return res.data.Form.save.id_form;
  } catch (e) {
    console.log(e.message);
    return false;
  }
}

export async function updateFormAPI(context, payload) {
  try {
    const res = await API.domain.crudForms({
      body: {
        option: payload.option,
        form_name: payload.form_name,
        form_description: payload.form_description,
        form_image: payload.form_image,
        form_style: payload.form_style,
        inputs: payload.inputs,
        final_information: payload.final_information,
        final_title: payload.final_title,
        id_form: payload.id_form,
      },
    });
    return true;
  } catch (e) {
    console.log(e.message);
    return false;
  }
}

// readFormComponent validates if the form has a valid id_course when it was read
export async function readFormComponent(context, payload) {
  context.commit("isLoading", true);
  try {
    const res = await API.domain.crudForms({
      body: {
        option: "read",
        id_form: payload,
        domain: window.DOMAIN,
      },
    });
    // WE VALIDATE IF ID_COURSE IS VALID
    // res.data.formCourse = {}
    if (!Object.keys(res.data.formCourse).length || (!!Object.keys(res.data.formCourse).length && !res.data.formCourse.live_mode) || (!!Object.keys(res.data.formCourse).length && res.data.formCourse.audience_type === 1 && !res.data.is_user_in_course && !!res.data.formCourse.live_mode)) {
      return false;
    } else {
      // SAVE CURRENT FORM IN THE STATE THAT THE USER WANTS TO EDIT
      context.commit("saveEditFormInfo", res.data);
      return true;
    }
  } catch (e) {
    console.log(e.message);
  } finally {
    context.commit("isLoading", false);
  }
}
// readForm reads the form normally without checking a valid id_course
export async function readForm(context, payload) {
  context.commit("isLoading", true);
  try {
    const res = await API.domain.crudForms({
      body: {
        option: "read",
        id_form: payload,
        domain: window.DOMAIN,
      },
    });
    console.log("Forma read", res.data);
    context.commit("saveEditFormInfo", res.data);
  } catch (e) {
    console.log(e.message);
  } finally {
    context.commit("isLoading", false);
  }
}

// UPLOAD PDF, WORD, EXCEL ETC.
export async function uploadFiles(context, payload) {
  try {
    console.log("Payload", payload);

    const res = await axios.post("/index.php?r=apprendo/uploadFormFile", {
      body: {
        id_form: payload.id_form,
        files: payload.files,
      },
    });
    console.log("Response", res);
    return true;
  } catch (e) {
    console.log(e.message);
    return false;
  }
}

// SUBMIT FINAL ANSWERS
export async function finalSubmit(context, payload) {
  context.commit("isLoading", true);
  try {
    const res = await API.domain.crudForms({
      body: {
        option: "saveAttempt",
        id_form: payload.id_form,
        id_form_course: payload.id_form_course,
        inputs: payload.inputs,
        domain: window.DOMAIN,
      },
    });

    return true;
  } catch (e) {
    console.log(e.message);
    return false;
  } finally {
    context.commit("isLoading", false);
  }
}
